import React from 'react';
import { MasterMedicine } from '../../../apis/master-medicines/types';
import HealtheraTable from '../../Table/Table';
import { convertMasterMedicinesToTable, prepareLoadingData } from './utils';

interface Props {
  masterMedicines: MasterMedicine[];
  page: number;
  rowsPerPage: number;
  rowsPerPageOptions: number[];
  total?: number;
  isLoading: boolean;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onPageChange: (event: React.ChangeEvent<HTMLDivElement>, page: number) => void;
}

const MasterMedicinesTable = ({
  masterMedicines,
  onRowsPerPageChange,
  onPageChange,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  total,
  isLoading
}: Props) => {
  const preparedData = isLoading ? prepareLoadingData(rowsPerPage) : convertMasterMedicinesToTable(masterMedicines);

  return (
    <HealtheraTable
      isLiveDashboard={false}
      data={preparedData}
      totalCount={total}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      onChangePage={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      page={page}
      displayPagination
    />
  );
};
export default MasterMedicinesTable;
